"use client";
import { type ComponentPropsWithoutRef } from "react";
import { useImgixImageURL } from "@/hooks/useImgixImageURL";

export interface ImageProps extends ComponentPropsWithoutRef<"img"> {
  fallbackSrc?: string;
  imgix?: boolean;
  imgixParams?: string;
}

export default function Image(props: ImageProps) {
  const { src, fallbackSrc, imgixParams, imgix = true, ...restProps } = props;
  const imgixSrc = useImgixImageURL(src as string, imgixParams);

  if (!src) {
    if (fallbackSrc) {
      // eslint-disable-next-line @next/next/no-img-element
      return <img src={fallbackSrc} loading="lazy" alt="" {...restProps} />;
    }
    return null;
  }

  if (imgix && imgixSrc) {
    return (
      // eslint-disable-next-line @next/next/no-img-element
      <img
        srcSet={`${imgixSrc}&dpr=1 1x, ${imgixSrc}&dpr=2 2x`}
        src={imgixSrc}
        loading="lazy"
        alt=""
        {...restProps}
      />
    );
  }

  // eslint-disable-next-line @next/next/no-img-element
  return <img src={src} loading="lazy" alt="" {...restProps} />;
}
